import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, UntypedFormArray, UntypedFormBuilder, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationEnd, Router, ActivatedRoute } from '@angular/router';
import { Constant } from 'src/app/constant/constant';
import { Location } from '@angular/common';
import { CalsoftAuditComponent } from 'src/app/pages/audit/audit.component';
import { CommonService } from 'src/app/services/common.service';
import { ResourceAccess } from 'src/app/shared/utils/calsoft-validators';
import { GoogleCalendarServiceAccountService } from 'src/app/services/google-calendar-service-account.service';
import { ProductService } from 'src/app/services/product.service';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import * as XLSX from 'xlsx';
import { GraphService } from 'src/app/services/graph.service';
import { OutLookService } from 'src/app/services/out-look.service';
import { NewEvent } from 'src/app/shared/outlook-calender/new-event';
import * as MicrosoftGraph from '@microsoft/microsoft-graph-types';
import { GoogleAuthService } from 'src/app/services/google-auth.service';

@Component({
  selector: 'calsoft-add-edit-google-calendar-service-account',
  templateUrl: './add-edit-google-calendar-service-account.component.html',
  styleUrls: ['./add-edit-google-calendar-service-account.component.scss']
})
export class AddEditGoogleCalendarServiceAccountComponent implements OnInit, OnDestroy {

  url = '';
  sanitizedUrl = '';


  firstFormGroup: FormGroup;
  text: any;
  title: string;
  id: any;
  resourcePrivilege: any;
  path: string;
  filtereddropdownTypeList: any;
  customerLinkList: any = [];
  private _onDestroy = new Subject<void>();
  form: any;
  addedFieldId: any = [];
  leadId: any = 0;
  leadDisplay: boolean = true;
  crmSettingsData: any;
  editMeeetingLink: any = 0;
  syncToOutLook: any;
  authenticated: any;
  syncToGoogleCalender: any;



  constructor(
    private _formBuilder: UntypedFormBuilder,
    private router: Router,
    private googleCalendarServiceAccountService: GoogleCalendarServiceAccountService,
    private snackBar: MatSnackBar,
    public location: Location,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private commonService: CommonService,
    private fb: FormBuilder,
    private productService: ProductService,
    private ecryptService: EcryptServiceService,
    private authService: OutLookService,
    private graphService: GraphService,
    private googleAuthService: GoogleAuthService

  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });
  }

  attendeeForm: any;

  ngOnInit(): void {

    this.getAllCrmData();

    this.initGoogleCalendarform();

    try {
      const encryptedData = localStorage.getItem('crmSettingsData');
      if (encryptedData) {

        const decrypted = this.ecryptService.decryptionAES(encryptedData);

        this.crmSettingsData = JSON.parse(decrypted);

        if (this.crmSettingsData['editCalenderLink'] != undefined) {

          this.editMeeetingLink = this.crmSettingsData['editCalenderLink']
        }


      }

    } catch (err) {
      console.error("Error decrypting crmSettingsData", err);
    }


    this.getResource();

    this.id = this.route.snapshot.params['googleCalenderId']

    if (this.id == 0) {


      if (this.route.snapshot.params['leadId'] != undefined) {

        this.leadId = this.route.snapshot.params['leadId'];

        this.firstFormGroup.value.entityId = this.leadId;

        this.leadDisplay = false;

      }


    }


    this.text = "Save";




    this.attendeeForm = this.fb.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]
      ]
    });

  }

  initGoogleCalendarform() {
    this.firstFormGroup = this._formBuilder.group({
      googleCalenderId: [0],
      summary: ['', Validators.required],
      description: ['', Validators.required],
      location: [''],
      timeZone: ['Asia/Kolkata'],
      eventId: [0],
      startDateTime: ['', Validators.required],
      endDateTime: ['', Validators.required],
      attendees: [''],
      meetLink: [''],
      data: [],
      startTime: ['', Validators.required],
      endTime: ['', Validators.required],
      meetingSummary: [''],
      status: ['Pending'],
      ownerId: [''],
      updatedBy: [''],
      createdBy: [''],
      entityId: [''],
      name: [''],
      meetingDriveLink: [''],
      type: [1]

    }, { validators: dateTimeRangeValidator() });
  }



  getResource() {
    this.commonService
      .getAllAccessForResource(ResourceAccess.GOOGLECALENDER)
      .subscribe((data: any) => {
        if ((this.id == 0 && !data.create) || (this.id != 0 && !data.update)) {

          this.router.navigate(['/unauthorized'])
        }
        this.resourcePrivilege = data;



        if (this.id > 0) {
          this.getGoogleCalendarById(this.id);
          this.title = 'Edit Meeting'
        }
        else {
          this.title = 'Add Meeting'
        }

      });
  }

  audit(i) {

    if (window.innerWidth > 768) {
      let dialogRef = this.dialog.open(CalsoftAuditComponent, {
        width: '900px',
        disableClose: true,
        data: { page: i, }
      });
      dialogRef.disableClose = false;
      dialogRef.afterClosed().subscribe(result => {

      });
    }
    else {
      let dialogRef = this.dialog.open(CalsoftAuditComponent, {
        minWidth: '100vw', height: '100vh',
        data: { page: i, }
      });
      dialogRef.disableClose = false;
      dialogRef.afterClosed().subscribe(result => {



      });
    }
  }

  getGoogleCalendarById(pk: number) {
    this.googleCalendarServiceAccountService.getGoogleCalendarById(pk)
      .subscribe(
        (googleCalendar: any) =>
          this.editGoogleCalendarform(googleCalendar),
        (err: any) => { }
      );
  }

  today: Date = new Date();

  editGoogleCalendarform(calendar: any) {

    this.attendeesList = [];
    if (calendar.attendees) {
      if (calendar.attendees.includes(',')) {
        this.attendeesList = calendar.attendees.split(',').map(item => item.trim());
      } else {
        this.attendeesList = [calendar.attendees.trim()];
      }
    }
    this.firstFormGroup = this._formBuilder.group({
      googleCalenderId: calendar.googleCalenderId,
      summary: calendar.summary,
      description: calendar.description,
      location: calendar.location,
      timeZone: calendar.timeZone,
      eventId: calendar.eventId,
      startDateTime: calendar.startDateTime,
      startTime: calendar.startTime,
      endDateTime: calendar.endDateTime,
      endTime: calendar.endTime,
      attendees: calendar.attendees,
      meetLink: calendar.meetLink,
      data: calendar.data,
      meetingSummary: calendar.meetingSummary,
      status: calendar.status,
      ownerId: calendar.ownerId,
      updatedBy: calendar.updatedBy,
      createdBy: calendar.createdBy,
      entityId: calendar.entityId,
      name: calendar.name,
      meetingDriveLink: calendar.meetingDriveLink,
      type: calendar.type
    });

  }




  createCalenderEvent() {

    const status = this.firstFormGroup.get('status')?.value;
    const meetingSummary = this.firstFormGroup.get('meetingSummary');

    if (meetingSummary) {
      if (status === 'Completed') {
        meetingSummary.setValidators([Validators.required]);
      } else {
        meetingSummary.clearValidators();
      }
      meetingSummary.updateValueAndValidity();
    }


    if (this.text == 'Save' && this.firstFormGroup.valid) {
      if (this.id != 0) {
        this.firstFormGroup.value.operationType = "Change"
      }
      else {
        this.firstFormGroup.value.operationType = "New"
      }

      if (this.route.snapshot.params['leadId'] != undefined) {

        this.leadId = this.route.snapshot.params['leadId'];

        this.firstFormGroup.value.entityId = this.leadId;

        this.firstFormGroup.value.type = 1;

        this.leadDisplay = false;

      }

      this.firstFormGroup.value.attendees = this.attendeesList
        .map(item => item.trim())
        .filter(item => item) // remove empty strings
        .join(',');
      this.firstFormGroup.value.startDateTime = this.getCombinedDateTime(this.firstFormGroup.value.startDateTime,
        this.firstFormGroup.value.startTime)

      this.firstFormGroup.value.endDateTime = this.getCombinedDateTime(this.firstFormGroup.value.endDateTime,
        this.firstFormGroup.value.endTime)


      this.firstFormGroup.patchValue(this.firstFormGroup.value);

      this.text = "Processing";

      let i = 0;

      this.firstFormGroup.patchValue(this.firstFormGroup.value);

      console.log(this.firstFormGroup.value);

      console.log(this.attendeesList);


      this.googleCalendarServiceAccountService.addOrEditGoogleCalendar(this.firstFormGroup.value).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.text = "Save";

            if (this.authenticated && this.syncToOutLook == 1) {
              this.onSubmit();
            }

            if (this.syncToGoogleCalender == 1) {
              this.syncToGoogleCal();
            }


            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });

            if (this.leadId == 0) {
              this.router.navigate(['/googleCalender'])
            } else {
              this.router.navigate([`leadDetail/${this.leadId}`])
            }

          }
          else {
            this.text = "Save";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => { this.text = "Save" });
    }
    else {

      if (this.attendeesList.length == 0) {

        this.snackBar.open('Add one Attendee atleast', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
      }
      this.firstFormGroup.markAllAsTouched();

      console.log(this.firstFormGroup);

    }
  }


  cancel() {
    this.location.back()
  }

  scopes = [
    { "viewValue": "Yes", "value": 1 },
    { "viewValue": "No", "value": 0 }
  ]


  statusList = [
    { "viewValue": "Pending", "value": "Pending" },
    { "viewValue": "Cancel", "value": "Cancel" },
    { "viewValue": "Completed", "value": "Completed" },
    { "viewValue": "Reschedule", "value": "Reschedule" },
    { "viewValue": "Missed", "value": "Missed" },
  ]


  attendeesList: any = [];


  removeLinkedCustomer(index) {


    this.attendeesList.splice(index, 1);

    (<UntypedFormArray>this.firstFormGroup.get('crmUserGroupEntity')).removeAt(index);
  }

  relatedCustomerList = [];
  customerSuperLinkList = [];

  statuss = [
    { viewValue: "Active", value: 1 },
    { viewValue: "Inactive", value: 0 }
  ]

  zone: any = [
    "Asia/Kolkata",
    "Asia/Dubai",
    "Asia/Singapore",
    "Asia/Tokyo",
    "Europe/London",
    "Europe/Paris",
    "Europe/Berlin",
    "America/New_York",
    "America/Chicago",
    "America/Denver",
    "America/Los_Angeles",
    "Australia/Sydney",
    "Australia/Perth",
    "Africa/Cairo",
    "Africa/Johannesburg",
    "Pacific/Auckland",
    "UTC",
  ]

  getCombinedDateTime(date, time): Date {
    const [hour, minute] = time.split(':').map(Number);
    date = new Date(date);

    date.setHours(hour);
    date.setMinutes(minute);
    date.setSeconds(0);
    date.setMilliseconds(0);

    return date;
  }


  email: string = '';
  emails: string[] = [];
  dialogRef!: MatDialogRef<any>;

  openDialog(templateRef: TemplateRef<any>) {
    this.email = '';
    this.emails = [];

    this.dialogRef = this.dialog.open(templateRef, {
      disableClose: true,
      width: window.innerWidth > 768 ? '900px' : '100vw',
      height: window.innerWidth > 768 ? '' : '100vh',
      panelClass: window.innerWidth > 768 ? '' : 'full-screen-dialog'
    });

    this.dialogRef.afterClosed().subscribe(() => {
      // optional: clean up
    });
  }


  closeDialog() {
    this.dialogRef.close();
  }






  addAttendee() {
    const email = this.attendeeForm.get('email')?.value.trim();
    if (email) {
      this.attendeesList.push(email);
      this.attendeeForm.reset();
    }
  }

  removeEmail(index: number) {
    this.emails.splice(index, 1);
  }

  confirmAddAttendees() {
    if (this.emails.length > 0) {
      this.attendeesList.push(...this.emails);
      this.emails = []; // clear temp list after confirming
    }
    this.dialogRef.close();
  }


  clearInputLead() {
    this.isOptionSelected = false;

    this.firstFormGroup.get('entityId')?.reset();

    this.firstFormGroup.get('name')?.reset();

  }

  isOptionSelected: boolean = false;
  onLeadSelected(event, option) {
    if (event.isUserInput != false) {
      this.isOptionSelected = true;
      this.firstFormGroup.get('entityId').setValue(option.entityId);
      this.firstFormGroup.get('name').setValue(option.name);

      if (option && option.email && option.email.trim()) {
        const leadEmail = option.email.trim();
        if (!this.attendeesList.includes(leadEmail)) {
          this.attendeesList.push(leadEmail);
        }
      } else {
        this.snackBar.open('Email ID is not available for the selected lead', '×', {
          panelClass: 'error',
          verticalPosition: 'bottom',
          duration: 3000
        });
      }
    }
  }

  onInputPaitent(event: Event): void {
    let inputElement = event.target as HTMLInputElement;
    let inputValue = inputElement.value.trim();

    if (inputValue.length > 2) {

      this.getLeadData(inputValue);
    }



  }


  leadList: any = [];
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  getLeadData(value) {


    let sortParam = 'updatedDate' + "," + Constant.Dsc;

    let search = "name:" + '*' + value.trim() + '*'
      + "' OR phoneNumber:" + '*' + value.trim() + '*'
      + "' OR ownerEmail:" + '*' + value.trim() + '*' + "' "


    this.productService.getLeadBySearch(search, this.page, this.size, sortParam).subscribe(
      res => {

        this.leadList = res['content'];




      },
      error => {

      })

  }

  generationLink() {
    this.googleCalendarServiceAccountService.generateMeetLink(this.id).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.firstFormGroup.value.referralId = response['data'];
          this.firstFormGroup.patchValue(this.firstFormGroup.value);
        }
        else {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => { this.text = "Save" });
  }


  copyToClipboard(text: string): void {
    const tempTextArea = document.createElement('textarea');
    tempTextArea.value = text;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand('copy');
    document.body.removeChild(tempTextArea);
    this.snackBar.open('Copied to clipboard!', 'X', {
      duration: 3000,
      verticalPosition: 'bottom',
      panelClass: ['success'],
    });
  }

  navigationTo(value) {
    window.open(value, '_blank');
  }



  selectedFile: File | null = null;

  isFileUploaded = false;

  onFileChange(event: any): void {
    const file: File = event.target.files[0];
    if (!file) return;
    this.selectedFile = file;
  }

  uploadedEmails: string[] = [];


  uploadFile(): void {
    if (!this.selectedFile) {
      console.error('No file to upload');
      return;
    }

    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
      const emails = data.slice(1).map((row: any[]) => row[0]).filter(email => !!email && typeof email === 'string');

      const uniqueUploadedEmails = Array.from(new Set(emails));

      const newEmails = uniqueUploadedEmails.filter(email => !this.attendeesList.includes(email));


      this.attendeesList.push(...newEmails);
      this.uploadedEmails = newEmails; // Track added emails
      this.selectedFile = null;
      this.isFileUploaded = true;
    };

    reader.readAsBinaryString(this.selectedFile);
  }



  cancelUpload(): void {
    this.attendeesList = this.attendeesList.filter(email => !this.uploadedEmails.includes(email));
    this.uploadedEmails = [];
    this.selectedFile = null;
    this.isFileUploaded = false;
  }

  model = new NewEvent();

  async onSubmit(): Promise<void> {
    if (this.firstFormGroup.invalid) {
      this.firstFormGroup.markAllAsTouched();
      return;
    }

    const formValue = this.firstFormGroup.value;
    const timeZone = this.authService.user?.timeZone ?? 'UTC';

    console.log(this.attendeesList);
    // Build a MicrosoftGraph.Event object
    const graphEvent: MicrosoftGraph.Event = {
      subject: formValue.summary,
      body: {
        contentType: "html",
        content: formValue.description
      },
      start: {
        dateTime: formValue.startDateTime,
        timeZone: timeZone
      },
      end: {
        dateTime: formValue.endDateTime,
        timeZone: timeZone
      },
      location: {
        displayName: formValue.location
      },
      attendees: this.attendeesList.map(email => ({
        emailAddress: {
          address: email,
        },
        type: "required"
      })),
      // 🔹 Add these two for Teams meeting
      isOnlineMeeting: true,
      onlineMeetingProvider: "teamsForBusiness"
    };

    console.log("Graph Event Payload: ", graphEvent);

    try {


      const response = this.graphService.addEventToCalendar(graphEvent);
      console.log('Event created:', response); // now response will have the created event


      this.snackBar.open("Event Created", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    } catch (error: any) {
      alert(error.message);
      this.snackBar.open(error.message, '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }
  }

  async signIn(): Promise<void> {
    await this.authService.signIn();
  }

  getAllCrmData() {

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {

          if (data.syncToOutlook != undefined) {
            this.syncToOutLook = data.syncToOutlook;
          } else {
            this.syncToOutLook = 0;
          }


          if (data['syncToGoogleCalender'] != undefined) {
            this.syncToGoogleCalender = data['syncToGoogleCalender'];
          } else {
            this.syncToGoogleCalender = 0;
          }

        }

      } catch (error) {
        console.error("Failed to decrypt crmSettingsData:", error);
      }
    }
  }

  setAuth(event) {

    this.authenticated = event;

    console.log(event);

  }

  async syncToGoogleCal(): Promise<void> {
    if (this.firstFormGroup.invalid) {
      this.firstFormGroup.markAllAsTouched();
      return;
    }
    const formValue = this.firstFormGroup.value;
    const graphEvent: any = {
      summary: formValue.summary,
      description: formValue.description,
      start: {
        dateTime: convertToGoogleCalendarFormat(formValue.startDateTime)
      },
      end: {
        dateTime: convertToGoogleCalendarFormat(formValue.endDateTime)
      },
      attendees: this.attendeesList.map(email => ({
        email: email
      })),
      reminders: { useDefault: true }
    };

    console.log("Graph Event Payload: ", graphEvent);

    try {
      this.googleAuthService.updateGoogleCalender(graphEvent).subscribe({
        next: (res) => {
          console.log('Event updated successfully', res);
        },
        error: (err) => {
          console.error('Error updating calendar', err);
        }
      });


      this.snackBar.open("Event Created", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    } catch (error: any) {
      alert(error.message);
      this.snackBar.open(error.message, '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
    }
  }

  sanitizeUrl(u: string): string {
    return (u || '').replace(/^\/+/, '').replace(/[?#&=]/g, '-').replace(/[^a-zA-Z0-9_-]+/g, '-').replace(/-+/g, '-').replace(/^[-]+|[-]+$/g, '').toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}

function dateTimeRangeValidator(): ValidatorFn {
  return (group: AbstractControl): { [key: string]: any } | null => {
    const startDate = group.get('startDateTime')?.value;
    const startTime = group.get('startTime')?.value;
    const endDate = group.get('endDateTime')?.value;
    const endTime = group.get('endTime')?.value;

    if (startDate && startTime && endDate && endTime) {
      const start = new Date(startDate);
      const [startHours, startMinutes] = startTime.split(':').map(Number);
      start.setHours(startHours, startMinutes, 0, 0);

      const end = new Date(endDate);
      const [endHours, endMinutes] = endTime.split(':').map(Number);
      end.setHours(endHours, endMinutes, 0, 0);

      return end >= start ? null : { dateTimeInvalid: true };
    }
    return null;
  };




}

function convertToGoogleCalendarFormat(utcDate: any) {
  const date = new Date(utcDate);

  // Convert to IST (+05:30)
  const offset = 5 * 60 + 30; // minutes
  const localTime = new Date(date.getTime() + offset * 60 * 1000);

  const pad = (n: number) => n.toString().padStart(2, '0');

  const year = localTime.getUTCFullYear();
  const month = pad(localTime.getUTCMonth() + 1);
  const day = pad(localTime.getUTCDate());
  const hours = pad(localTime.getUTCHours());
  const minutes = pad(localTime.getUTCMinutes());
  const seconds = pad(localTime.getUTCSeconds());

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+05:30`;


}

